import { AppButton } from 'components/form';
import { Select } from '@trackman/web-shared-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type SelectFilterProps = {
  filter: { options: any[]; type: string; selectProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const SelectFilter = ({ filter, onApply }: SelectFilterProps) => {
  const [value, setValue] = useState<string | number | undefined>();
  const { t } = useTranslation();

  return (
    <div className='data-table-filter-content gap-10px'>
      <Select
        label={filter?.label || ''}
        value={value}
        notched={false}
        selectOptions={filter?.options || []}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        onChange={(e) => {
          setValue(e.target.value as string | number | undefined);
        }}
      />

      <AppButton
        data-test='ApplySelectFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply(value)}
      >
        {t('apply')}
      </AppButton>
    </div>
  );
};

export default SelectFilter;
